/*
export para funcao de chamadas API REST
- estas funções estão sendo utilizadas na STORE.JS

apiOrds: efetua a requisicao no servidor ORDS e retorna o resultado


TRATAMENTO DE EXCECAO:
global-functions.js -> Vue.prototype.$restRegisterInterceptor

*/

import Vue from 'vue'
import axios from 'axios'
import { SysVars } from '../main'

export const apiORDS = (url, params, noSpin) => {
  let path = url
  if (params && params.id) {
    path = path + params.id
  }
  if (params && params.filter) {
    path = path + '?q=' + params.filter
  }
  if (params && params.query) {
    path = path + '?' + params.query
  }
  if (params && params.page) {
    if (params.filter || params.query) {
      path = path + '&offset=' + params.page
    } else {
      path = path + '?offset=' + params.page
    }
  }
  if (params && params.offset) {
    if (params.filter || params.query) {
      path = path + '&offset=' + params.offset
    } else {
      path = path + '?offset=' + params.offset
    }
  }
  if (params && params.limit) {
    if (params.filter || params.query) {
      path = path + '&limit=' + params.limit
    } else {
      path = path + '?limit=' + params.limit
    }
  }
  if (params && params.body) {
    if (params.filter || params.query) {
      path = path + '&filtros=' + params.body
    } else {
      path = path + '?filtros=' + params.body
    }
  }

  if (!noSpin)
    Vue.prototype.$appLoading(true)
  return axios.get(path)
    .then((data) => {
      Vue.prototype.$serverError(false)
      if (!noSpin)
        Vue.prototype.$appLoading(false)
      return data.data
    })
}

export const apiORDSgetViaPost = (url, params, noSpin) => {
  let path = url
  if (params && params.id) {
    path = path + params.id
  }
  if (params && params.filter) {
    path = path + '?q=' + params.filter
  }
  if (params && params.query) {
    path = path + '?' + params.query
  }
  if (params && params.page) {
    if (params.filter || params.query) {
      path = path + '&offset=' + params.page
    } else {
      path = path + '?offset=' + params.page
    }
  }
  if (params && params.offset) {
    if (params.filter || params.query) {
      path = path + '&offset=' + params.offset
    } else {
      path = path + '?offset=' + params.offset
    }
  }
  if (params && params.limit) {
    if (params.filter || params.query) {
      path = path + '&limit=' + params.limit
    } else {
      path = path + '?limit=' + params.limit
    }
  }

  let data = params.body

  if (!noSpin)
    Vue.prototype.$appLoading(true)
  return axios.post(path, data)
    .then((data) => {
      Vue.prototype.$serverError(false)
      if (!noSpin)
        Vue.prototype.$appLoading(false)
      return data.data
    })
}


export const apiORDSpostlongtimeout = (store, modulo, data, metodo, params, token) => {
  //CHAMADA API ORDS METODO POST OU PUT
  var path = urlORDS(store, modulo, params)
  Vue.prototype.$appLoading(true)
  if (metodo == 'post') {
    return axios.post(path, data, { timeout: 1200000 })
      .then((data) => {
        Vue.prototype.$serverError(false)
        Vue.prototype.$appLoading(false)
        return data.data
      })
  } else if (metodo == 'put') {
    return axios.put(path, data, { timeout: 1200000 })
      .then((data) => {
        Vue.prototype.$serverError(false)
        Vue.prototype.$appLoading(false)
        return data.data
      })
  }
  Vue.prototype.$appLoading(false)
}


export const apiORDSpost = (store, modulo, data, metodo, params, token) => {
  //CHAMADA API ORDS METODO POST OU PUT
  var path = urlORDS(store, modulo, params)
  Vue.prototype.$appLoading(true)
  if (metodo == 'post') {
    return axios.post(path, data)
      .then((data) => {
        Vue.prototype.$serverError(false)
        Vue.prototype.$appLoading(false)
        return data.data
      })
  } else if (metodo == 'put') {
    return axios.put(path, data)
      .then((data) => {
        Vue.prototype.$serverError(false)
        Vue.prototype.$appLoading(false)
        return data.data
      })
  }
  Vue.prototype.$appLoading(false)
}

export const lojaORDSpost = (store, modulo, data, metodo, params, token) => {
  //CHAMADA API ORDS METODO POST OU PUT
  var path = urlLoja(store, modulo, params)
  Vue.prototype.$appLoading(true)
  if (metodo == 'post') {
    return axios.post(path, data)
      .then((data) => {
        Vue.prototype.$serverError(false)
        Vue.prototype.$appLoading(false)
        return data.data
      })
  } else if (metodo == 'put') {
    return axios.put(path, data)
      .then((data) => {
        Vue.prototype.$serverError(false)
        Vue.prototype.$appLoading(false)
        return data.data
      })
  }
  Vue.prototype.$appLoading(false)
}


export const apiORDSapp = (vm, url, metodo, data, params) => {
  //CHAMADA API ORDS /nbapp/
  var path = vm.$store.getters.urlApp + url
  if (params && params.id) {
    path = path + params.id
  }
  Vue.prototype.$appLoading(true)
  if (metodo == 'get') {
    return axios.get(path)
      .then((data) => {
        Vue.prototype.$serverError(false)
        Vue.prototype.$appLoading(false)
        return data.data
      })
  }
  if (metodo == 'post') {
    return axios.post(path, data)
      .then((data) => {
        Vue.prototype.$serverError(false)
        Vue.prototype.$appLoading(false)
        return data.data
      })
  } else if (metodo == 'put') {
    return axios.put(path, data)
      .then((data) => {
        Vue.prototype.$serverError(false)
        Vue.prototype.$appLoading(false)
        return data.data
      })
  } else if (metodo == 'delete') {
    return axios.delete(path, data)
      .then((data) => {
        Vue.prototype.$serverError(false)
        Vue.prototype.$appLoading(false)
        return data.data
      })
  }
  Vue.prototype.$appLoading(false)
}

export const apiORDSauth = (data) => {
  //CHAMADA API ORDS METODO AUTH/TOKEN PARA OBTER O TOKEN
  let url = data.urlapi + '/oauth/token'
  let config = {
    headers: {
      'Authorization': 'Basic ' + data.token,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  }
  let body = 'grant_type=client_credentials'

  Vue.prototype.$appLoading(true)
  return axios.post(url, body, config)
    .then((data) => {
      Vue.prototype.$serverError(false)
      Vue.prototype.$appLoading(false)
      return data.data
    })

  Vue.prototype.$appLoading(false)
  return false
}

export const apiORDSdelete = (state, modulo, token) => {
  //CHAMADA API ORDS METODO DELETE
  var path = urlORDS(state, modulo)
  Vue.prototype.$appLoading(true)
  return axios.delete(path)
    .then(() => {
      Vue.prototype.$serverError(false)
      Vue.prototype.$appLoading(false)
      return
    })
  Vue.prototype.$appLoading(false)
}

export const apiORDSdelete2 = (url) => {
  //CHAMADA API ORDS METODO DELETE
  Vue.prototype.$appLoading(true)
  return axios.delete(url)
    .then(() => {
      Vue.prototype.$serverError(false)
      Vue.prototype.$appLoading(false)
      return
    })
  Vue.prototype.$appLoading(false)
}

export const apiORDSmidia = (url, params) => {
  //CHAMADA NA API ORDS PARA DOWNLOAD DE MIDIA (IMAGENS)
  var path = url
  if (params && params.id) {
    path = path + params.id
  }
  if (params && params.filter) {
    path = path + '?q=' + params.filter
  }
  if (params && params.page) {
    if (params.filter) {
      path = path + '&offset=' + params.page
    } else {
      path = path + '?offset=' + params.page
    }
  }
  Vue.prototype.$appLoading(true)
  return axios.get(path, { responseType: "blob" })
    .then((data) => {
      Vue.prototype.$serverError(false)
      Vue.prototype.$appLoading(false)
      return data.data
    })
  Vue.prototype.$appLoading(false)
}


export function apiMetadata(url) {
  //CHAMADA APP SERVER PARA RETORNAR O OBJETO METADATA
  return axios.get(url)
    .then((response) => {
      Vue.prototype.$serverError(false)
      return response.data.entities
    })
}

export function urlORDS(store, modulo, params) {
  //FUNCAO QUE MONTA A URL PARA ACESSO À API ORDS
  var url = store.getters.urlOrds + modulo
  if (params && params.id) {
    url = url + params.id
  }
  return url
}

export function urlAPP(state, modulo, params) {
  //FUNCAO QUE MONTA A URL PARA ACESSO À API PRINCIPAL ords/nbapp/
  var url = state.urlApp + modulo
  if (params && params.id) {
    url = url + params.id
  }
  return url
}

export function urlLoja(store, modulo, params) {
  //FUNCAO QUE MONTA A URL PARA ACESSO À API ORDS
  var url = store.getters.urlLoja + modulo
  if (params && params.id) {
    url = url + params.id
  }
  return url
}


export function apiDateORDS(pDate, ulthora) {
  //retorna o campo data formatado para a query string do ORDS
  //{"$date":"2018-09-12T00:00:00Z"}
  if ((!pDate) || (pDate == '')) {
    return ''
  }
  if (ulthora) {
    return pDate + 'T23:59:59Z'
  } else {
    return pDate + 'T00:00:00Z'
  }

}

export function apiEmailPDF(self, module, data) {
  /* chamada API para envio de emails ORDS/NBAPP/EMAIL/ (pedido de venda, cotacao, pedido de compra, danfe, etc)
  data:
    sendto: '',
    subject: '',
    text: '',
    codnf: uuid
  */

  var path = self.$store.getters.urlApp + 'email/' + module
  Vue.prototype.$appLoading(true)
  Vue.prototype.$serverError(false)
  return axios.post(path, data)
    .then((data) => {
      Vue.prototype.$serverError(false)
      Vue.prototype.$appLoading(false)
      if (data.data && data.data.errmessages) {
        Vue.prototype.$erpToastError(data.data.errmessages[0])
      } else {
        Vue.prototype.$erpToastSuccess('O Email foi enviado')
        return data.data
      }
    })
  Vue.prototype.$appLoading(false)
}


export function apiDownloadPDF(self, module, data, metodo, open, filename, print) {
  //efetua download de arquivos pdf da api ORDS/NBAPP (pedido de venda, cotacao, pedido de compra, danfe, etc)
  //o servidor está enviando o arquivo em BASE64 pelo fato da rotina apiDownloadFile estar mudando o character-set do arquivo

  var url = self.$store.getters.urlApp + module

  if (module.includes('boleto') || module.includes('cnab') || module.includes('xmlhist') || module.includes('etiqueta') || module.includes('nfse')) {
    url = self.$store.getters.urlOrds + module
  }

  if (module.includes('htmlpdf')) {
    url = 'https://teste.notabrasil.com.br/htmlpdf'
    // url = '/htmlpdf'
  }

  url = url.replace('empresa.uuid', self.$store.getters.getEnv.uuid)

  Vue.prototype.$appLoading(true)
  Vue.prototype.$serverError(false)
  if (!metodo || metodo === 'get') {
    self.$http.get(url)
      .then(response => {
        Vue.prototype.$appLoading(false)
        if (response.data && response.data.errmessages) {
          Vue.prototype.$erpToastError(response.data.errmessages[0])
        } else {
          if (!open)
            apiSavePDF(response, filename)  //para o CRM deve salvar o arquivo
          else
            apiOpenPDF(response, print)
        }
      }, response => {
        Vue.prototype.$appLoading(false)
      })
  } else
    if (metodo && metodo === 'post') {
      //postConfig acrescentado para solucionar problema no serviço htmlpdf
      let postConfig = {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        responseType: 'blob',
      }
      self.$http.post(url, data, postConfig)
        .then(response => {
          Vue.prototype.$appLoading(false)
          if (response.data && response.data.errmessages) {
            Vue.prototype.$erpToastError(response.data.errmessages[0])
          } else {
            if (!open)
              apiSavePDF(response, filename)  //para o CRM deve salvar o arquivo
            else
              apiOpenPDF(response, print)
          }
        }, response => {
          Vue.prototype.$appLoading(false)
        })
    }
}

export function apiDownload2(self, module, data, metodo, notProcessDownload) {
  let url = self.$store.getters.urlOrds + module

  Vue.prototype.$appLoading(true)
  if (metodo == 'get') {
    return axios.get(url, { responseType: 'blob' }).then((response) => {
      Vue.prototype.$serverError(false)
      Vue.prototype.$appLoading(false)
      if (!notProcessDownload)
        apiDownloadFile(response)
      else
        return response
    })
  }

  if (metodo == 'post') {
    return axios.post(url, data, { responseType: 'blob' }).then((response) => {
      Vue.prototype.$serverError(false)
      Vue.prototype.$appLoading(false)
      if (!notProcessDownload)
        apiDownloadFile(response)
      else
        return response
    })
  }
}

export function apiOpenPDF(pdf, print) {
  //abre o arquivo PDF em outra janela
  const features = "width=800,height=600,left=100,top=100,toolbar=no,menubar=no,scrollbars=yes,resizable=yes"
  const pdfWindow = window.open("", "_blank", features)

  if (!pdfWindow || pdfWindow.closed || typeof pdfWindow.closed == 'undefined') {
    Vue.prototype.$erpToastError('Desabilitar bloqueador de Pop-up para visualizar impressão da NF')
    return
  }

  // pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdf.data) + "'></iframe>")
  const iframe = pdfWindow.document.createElement('iframe')
  iframe.style.width = '100%'
  iframe.style.height = '100%'
  iframe.style.border = 'none'
  iframe.src = 'data:application/pdf;base64,' + encodeURI(pdf.data)

  // Espera o iframe carregar
  iframe.onload = function() {
    if (print) {
      pdfWindow.focus() // foca na nova janela
      pdfWindow.print()
    }
  }

  pdfWindow.document.body.style.margin = 0
  pdfWindow.document.body.appendChild(iframe)
}

export function apiSavePDF(pdf, filename) {
  //salva o arquivo PDF
  if (pdf.data instanceof Blob) {
    apiSavePDFBlob(pdf, filename)
    return
  }

  //RECEBE ARQUIVO PDF EM BASE 64
  let name = 'unknown.pdf';
  const contentDisposition = pdf.headers['content-disposition'];
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
    if (fileNameMatch.length === 2)
      name = fileNameMatch[1];
  }

  const linkSource = `data:application/pdf;base64,${pdf.data}`;
  const downloadLink = document.createElement("a");

  downloadLink.href = linkSource;
  downloadLink.download = name;
  downloadLink.click();
}

export function apiSavePDFBlob(response, filename) {
  var newBlob = new Blob([response.data], { type: 'application/pdf' })

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }


  let name = 'unknown';
  if (!filename) {
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
      if (fileNameMatch.length === 2)
        name = fileNameMatch[1];
    }
  } else {
    name = filename
  }

  const data = window.URL.createObjectURL(newBlob)
  var link = document.createElement('a')
  link.href = data
  link.download = name
  link.click()
  setTimeout(function() {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
  }, 100)
}

export function apiDownload(self, module, data, metodo, notProcessDownload) {
  /* DOWNLOAD DE ARQUIVOS DO SERVIDOR ORDS/NBAPP */

  var url = self.$store.getters.urlApp + module
  if (module.includes('cnab')) {
    url = self.$store.getters.urlOrds + module
  }

  /* download teste de arquivo ZIP
  url = 'http://localhost:1049/nfexmlfiles?mes=10&ano=2019&codempresa=6&codfil=1&base=NBDATA000006'
  */

  Vue.prototype.$appLoading(true)
  if (metodo == 'get') {
    return axios.get(url, { responseType: 'blob' }).then((response) => {
      Vue.prototype.$serverError(false)
      Vue.prototype.$appLoading(false)
      if (!notProcessDownload)
        apiDownloadFile(response)
      else
        return response
    })
  }
  if (metodo == 'post') {
    return axios.post(url, data, { responseType: 'blob' }).then((response) => {
      Vue.prototype.$serverError(false)
      Vue.prototype.$appLoading(false)
      if (!notProcessDownload)
        apiDownloadFile(response)
      else
        return response
    })
  }
}

export function str2bytes(str) {
  var bytes = new Uint8Array(str.length);
  for (var i = 0; i < str.length; i++) {
    bytes[i] = str.charCodeAt(i);
  }
  return bytes;
}

export function apiDownloadFile(response, filename) {
  //ATENCAO: rotina nao utilizada para download de PDF pelo fato de alterar o character-set do arquivo e causar problema de acentuação

  //trata o download do arquivo recebido da api

  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  //    var newBlob = new Blob([response.data], {type: response.headers['content-type']})
  var newBlob = new Blob([response.data], { type: 'text/json' })
  //var newBlob = new Blob([response.data], {type: 'application/zip'})
  //var url = window.URL.createObjectURL(newBlob)
  //window.open(url);
  //return

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  let name = 'unknown';

  if (!filename) {
    const contentDisposition = response.headers['content-disposition'];

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
      if (fileNameMatch.length === 2)
        name = fileNameMatch[1];
    }
  } else {
    name = filename
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob)
  var link = document.createElement('a')
  link.href = data
  link.download = name
  link.click()
  setTimeout(function() {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
  }, 100)
}


export function apiAutNFe(self, pFilial, pCodNF) {
  /* efetua o envio da nota fiscal para SEFAZ  */

  var url = self.$store.getters.urlApp + 'apinfe/autnfe/filial/' + pFilial + '/nfs/' + pCodNF

  Vue.prototype.$appLoading(true)
  return axios.get(url).then((response) => {
    Vue.prototype.$appLoading(false)
    return response
  })
}


export function apiAutNFSe(self, pCodNF) {

  let url = urlORDS(self.$store, 'nfse/autoriza/' + pCodNF)
  return apiORDS(url, null, true).then((response) => {
    return response
  });

}

export function apiSyncNFSe(self, pCodNF) {

  let url = urlORDS(self.$store, 'nfse/sincroniza/' + pCodNF)
  return apiORDS(url, null, true).then((response) => {
    return response
  });

}



export function apiConsultaCadastro(self, pCNPJ, pUF, callBack) {
  let url = 'consultacadastro/' + pCNPJ
  if (pUF)
    url = url + '?uf=' + pUF

  apiORDSapp(self, url, 'get').then(data => {
    if (data.errmessages) {

    } else {
      let dados = data
      dados.endereco = self.$removerAcentos((dados.endereco || '').toUpperCase())
      dados.nr = self.$removerAcentos((dados.nr || '').toUpperCase())
      dados.bairro = self.$removerAcentos((dados.bairro || '').toUpperCase())
      dados.mun = self.$removerAcentos((dados.mun || '').toUpperCase())
      if (callBack)
        callBack(dados)
    }
  })
}

export const apiValidaLimitePlano = async (vm, recurso) => {
  var path = vm.$store.getters.urlApp + 'planos/validarecurso/' + recurso

  // return axios.get(path).then((data) => {
  //   if (data.data.limitePlano) {
  //     if (recurso == 'usuarios')
  //       SysVars.limiteUsuariosAlcancado = true
  //     SysVars.showLimitePlano = true
  //     SysVars.limitePlanoMensagem = data.data.message
  //     return false
  //   }
  //   else
  //     return true
  // })

  const data = await axios.get(path)
  if (data && data.data.limitePlano) {
    if (recurso == 'usuarios')
      SysVars.limiteUsuariosAlcancado = true
    SysVars.showLimitePlano = true
    SysVars.limitePlanoMensagem = data.data.message
    return false
  }
  else
    return true
}

export const apiRecursoLiberado = (vm, recurso) => {
  var recList = vm.$store.getters.getSessao.recursos_plano
  recList = JSON.parse(recList)


  if (!recList)
    return true

  let recId = null

  let recursoLiberado = false

  if (recurso == 'nfe')
    recId = 'E22157F5AD8E7BF2E0530100007F163B'
  else
    if (recurso == 'nfce')
      recId = 'E22157F5AD937BF2E0530100007F163B'
    else
      if (recurso == 'sat')
        recId = 'E22157F5AD927BF2E0530100007F163B'
      else
        if (recurso == 'financeiro')
          recId = 'EF2CF5AF0C2A644AE0530100007F58DF'
        else
          if (recurso == 'estoque')
            recId = 'EF2CF5AF0C2B644AE0530100007F58DF'
          else
            if (recurso == 'nfimportacao')
              recId = '016415DCCF0006DAE0630100007FA0CB'
            else
              if (recurso == 'nfimportacao_xmldi')
                recId = 'EF2CF5AF0C2F644AE0530100007F58DF'
              else
                if (recurso == 'varejo')
                  recId = 'E22157F5AD947BF2E0530100007F163B'
                else
                  if (recurso == 'regaimp')
                    recId = 'E28170AE07D00331E0530100007F2060'
                  else
                    if (recurso == 'nfentrada')
                      recId = 'E22157F5AD977BF2E0530100007F163B'
                    else
                      if (recurso == 'pedido')
                        recId = 'E22157F5AD967BF2E0530100007F163B'
                      else
                        if (recurso == 'lojaonline')
                          recId = 'E28170AE07CF0331E0530100007F2060'
  if (recurso == 'consultascomercial')
    recId = 'FFD312868DB76ED4E0530100007FA634'
  if (recurso == 'consultasestoque')
    recId = 'FFD312868DB86ED4E0530100007FA634'
  if (recurso == 'consultasfinanceiro')
    recId = 'FFD312868DB96ED4E0530100007FA634'


  if (SysVars.plano && SysVars.plano.app && SysVars.plano.app.length > 0 && SysVars.plano.app[0].app == 'ERP') {
    return true;
  }

  if (recId) {
    let recFound = recList.filter((obj) => {
      return obj.uuid == recId
    })
    if (recFound.length > 0 && recFound[0].ativo) {
      recursoLiberado = true
    }
    return recursoLiberado
  }
  else
    return true
}

export const apiMenuLiberado = (vm, recurso) => {
  if (recurso == 'varejo' && SysVars.appVarejo)
    return true
  else
    if (recurso == 'lojaonline' && SysVars.appLoja)
      return true
    else
      return apiRecursoLiberado(vm, recurso)
}



// WEBPACK FOOTER //
// ./src/shared/api-functions.js